import Toast from './Toast';

let toast = null;

const notice = (type, text = '', duration = 2000) =>{
    if (!toast) {
        toast = Toast
    }
    if(!text) return;
    text = text.toString();
    return toast.add({
        type,
        text,
        duration,
    })
}

export default {
    info: (text, duration) => notice('info', text, duration),
    success: (text, duration) => notice('success', text, duration),
    error: (text, duration) => notice('error', text, duration),
    warning: (text, duration) => notice('warning', text, duration),
    hide: ()=>{ if(toast) { return toast.destroy() }},
}